import GroupCardView from './GroupCard.view';

export default GroupCardView;
